var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlms6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.051,
    height: 90.507,
    viewBox: "0 0 91.051 90.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.575 24.816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.324,191.73a10.175,10.175,0,0,0-7.96-7.116l-9.579-1.743v-.756a14.624,14.624,0,0,0,7.023-9.824,5.849,5.849,0,0,0,4.655-5.718V152.153a9.154,9.154,0,0,0-6.54-8.784l-.73-.73a17.975,17.975,0,0,0-30.685,12.71v11.221a5.849,5.849,0,0,0,4.655,5.718,14.625,14.625,0,0,0,7.023,9.824v.756l-9.579,1.742a10.179,10.179,0,0,0-7.96,7.118l-3.4,11.337h56.476Zm-10.24-22.644v-5.028a2.894,2.894,0,0,1,0,5.028Zm-29.2,0a2.894,2.894,0,0,1,0-5.028Zm0-9.813v1.667a5.791,5.791,0,0,0-1.46.6V155.35a15.055,15.055,0,0,1,25.7-10.645l1.288,1.289.393.1a6.239,6.239,0,0,1,4.734,6.062v9.391a5.737,5.737,0,0,0-1.46-.6v-1.667h-4.629a12.7,12.7,0,0,1-10.109-5.052l-1.161-1.55-2.9,2.9a12.559,12.559,0,0,1-8.937,3.7Zm2.92,10.218v-7.366a15.451,15.451,0,0,0,9.541-4.489l.568-.568a15.637,15.637,0,0,0,11.538,5.124h1.709v7.3a11.678,11.678,0,1,1-23.357,0Zm7.423,13.961a14.543,14.543,0,0,0,8.511,0l-4.255,3.191Zm2.033,5.173-2.979,2.978-1.933-5.8.93-.168Zm8.426-2.987.928.169-1.933,5.8-2.979-2.978Zm-30.518,14.507,2.274-7.578a7.263,7.263,0,0,1,5.686-5.083l6.321-1.149,3.557,10.674,6.476-6.479,6.477,6.477,3.557-10.674,6.321,1.149a7.269,7.269,0,0,1,5.686,5.083l2.273,7.579Z",
    transform: "translate(-189.248 -137.376)",
    fill: "#666"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.042 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.954,24.979V15.727l-3.962-1.055q-.175-.458-.382-.915L35.667,10.2l-6.54-6.54L25.574,5.72c-.3-.139-.609-.266-.912-.382L23.6,1.376H14.353L13.294,5.339q-.458.175-.912.382L8.829,3.663,2.289,10.2l2.057,3.553c-.14.305-.267.61-.384.915L0,15.727v9.252l3.962,1.055c.117.305.244.61.384.915L2.289,30.5l6.54,6.54,3.553-2.057c.3.139.609.266.912.382l1.058,3.962H23.6l1.058-3.963q.458-.175.912-.382l3.553,2.057,6.54-6.54-2.057-3.553c.139-.305.267-.61.382-.915Zm-5.938,5.044-3.369,3.371-2.971-1.721-.709.363A13.293,13.293,0,0,1,23,32.859l-.758.244-.882,3.308H16.595L15.713,33.1l-.758-.244a13.452,13.452,0,0,1-1.968-.823l-.709-.363L9.308,33.393,5.938,30.023l1.72-2.969-.363-.709a13.053,13.053,0,0,1-.822-1.968l-.244-.759L2.92,22.736V17.971l3.309-.882.244-.759a13.179,13.179,0,0,1,.822-1.968l.363-.709-1.72-2.969L9.308,7.313l2.971,1.721.709-.363a13.294,13.294,0,0,1,1.968-.823l.758-.244L16.595,4.3H21.36L22.241,7.6,23,7.847a13.452,13.452,0,0,1,1.968.823l.709.363,2.971-1.721,3.369,3.371L30.3,13.653l.363.709a13.053,13.053,0,0,1,.822,1.968l.244.759,3.309.882v4.765l-3.309.882-.244.759a13.179,13.179,0,0,1-.822,1.968l-.363.709Z",
    transform: "translate(0 -1.376)",
    fill: "#666"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.801 8.759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.42,65.692a10.216,10.216,0,1,0-1.972,2l-1.781-2.312a7.229,7.229,0,0,1-4.448,1.509,7.3,7.3,0,1,1,7.3-7.3,7.233,7.233,0,0,1-1.439,4.353Z",
    transform: "translate(-48 -49.376)",
    fill: "#666"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.813 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.244,19.321l-1.888,1.888V15.974a14.614,14.614,0,0,0-14.6-14.6H344V4.3h8.759a11.692,11.692,0,0,1,11.678,11.678v5.235l-1.887-1.888-2.064,2.064L365.9,26.8l5.411-5.411Z",
    transform: "translate(-344 -1.376)",
    fill: "#666"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.47 65.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.215,368.887v-5.235L11.1,365.54l2.064-2.064-5.411-5.411-5.411,5.411,2.064,2.064L6.3,363.652v5.235a14.614,14.614,0,0,0,14.6,14.6v-2.92A11.692,11.692,0,0,1,9.215,368.887Z",
    transform: "translate(-2.344 -358.064)",
    fill: "#666"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 43.778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.753,
    height: 2.221,
    transform: "translate(0 0)",
    fill: "#666"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.882)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.753,
    height: 3.331,
    fill: "#666"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 49.33)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.766,
    height: 3.331,
    transform: "translate(0 0)",
    fill: "#666"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.479 49.633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.394,273.376H112v2.92h17.517v-2.92Z",
    transform: "translate(-112 -273.376)",
    fill: "#666"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.629 0.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.331,
    height: 3.331,
    transform: "translate(0 0)",
    fill: "#666"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.078 0.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.221,
    height: 3.331,
    transform: "translate(0 0)",
    fill: "#666"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.208 88.193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.331,
    height: 2.221,
    transform: "translate(0)",
    fill: "#666"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.76 88.193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.331,
    height: 2.221,
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlms6);
export default __webpack_public_path__ + "static/media/plms6.ece690ce72dad335bba9504bed5f92fc.svg";
export { ForwardRef as ReactComponent };